import MinorSelect from "./MinorSelect";

export default MinorSelect;
